import 'owl.carousel';
import { Fancybox } from "@fancyapps/ui";
import arrowprev from '../assets/images/left.svg';
import arrownext from '../assets/images/right.svg';

$('.home-full-slider').owlCarousel({
    loop: true,
    nav: false,
    margin: 0,
    items: 1,
    dots: false,
    smartSpeed: 2000,
    dotsSpeed: 2000,
    autoplay: true,
    animateOut: 'fadeOut',
    autoplayTimeout: 5000,
    autoplayHoverPause: false
});

$('.contact-slider, .proyect-slider').owlCarousel({
    loop: true,
    nav: false,
    margin: 0,
    items: 1,
    dots: true,
    smartSpeed: 2000,
    dotsSpeed: 2000,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: false
});

$('.slider-bottom').owlCarousel({
    loop: true,
    nav: true,
    margin: 0,
    items: 1,
    dots: true,
    smartSpeed: 2000,
    dotsSpeed: 2000,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: false,
    navText: [`<img src="${arrowprev}">`,`<img src="${arrownext}">`],
});

$('.nav-mobile').on('click', function(e){
    e.preventDefault();
    $('.nav-main').fadeIn(400).css('display', 'flex');
});
$('.nav-close-mobile').on('click', function(e){
    e.preventDefault();
    $('.nav-main').fadeOut(400);
});

let isContactFormAjax = false;
$('#contact-form').on('submit', function(){
    $('.ajax-message').hide().removeClass('alert-danger alert-success');

    if (isContactFormAjax) return;
    let form = $(this);

    isContactFormAjax = true;
    let formData = new FormData(this);

    fetch($(this).attr('action'), {
        method: $(this).attr('method'),
        body: formData
    })
    .then(function (response) {
        return response.json();
    }).then(function (response) {
        if (response.success) {
            form.trigger('reset');
            form.find('.ajax-message').addClass('alert-success').text(response.data.message).show();
        } else {
            form.find('.ajax-message').addClass('alert-danger').text(response.data.message).show();
        }
        
        isContactFormAjax = false;
    }).catch(function (err) {
        isContactFormAjax = false;
    });
});

var player;

window.onYouTubeIframeAPIReady = function() {
    player = new YT.Player('video-iframe', {
    events: {
        'onReady': onPlayerReady
    }
    });
}
window.onPlayerReady = function(event) {
    var videoPreview = document.getElementById('preview');
    videoPreview.addEventListener('click', function() {
        document.getElementById('video-preview').classList.add('hidden');
        videoPreview.classList.add('hidden');
        player.playVideo();
    });
}